import type { PrimaryNavigationDestination } from "@-/dev.improve.haniverse.database.schemas.actor.schema._tables.user";
import { PRIMARY_NAVIGATION_DESTINATION_PRESENTATIONS } from "@-/dev.improve.haniverse.routes.nav._lib.primary-navigation-customization";
import { AnimatedPrimaryNavigationStripIcon } from "#animated-primary-navigation-strip-icon";
import { useOnboardingDestinationReveal } from "#use-onboarding-destination-reveal";

/**
 * A destination's strip icon, drawn from the shared presentation table. `tabName` is the screen
 * it drives, when that is not the destination's own (the map is Learn's tab presented as the map).
 * A destination a new learner's onboarding has just unlocked pops into place.
 */
export function PrimaryNavigationStripDestinationIcon({
  destination,
  tabName = destination,
}: {
  destination: PrimaryNavigationDestination;
  tabName?: string;
}) {
  const { icon, iconSize } = PRIMARY_NAVIGATION_DESTINATION_PRESENTATIONS[destination];
  const revealProgress = useOnboardingDestinationReveal(destination);
  return (
    <AnimatedPrimaryNavigationStripIcon
      inactiveSize={iconSize}
      name={icon}
      revealProgress={revealProgress}
      tabName={tabName}
    />
  );
}
